module.exports = __webpack_public_path__ + "img/battery-working-one.4cb4cf5e.svg";